import React, { useEffect, useState } from "react";
import {
  FaBell,
  FaExclamationTriangle,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { getSubscriptionAlerts } from "../../services/notificationService";

const NotificationAlertLayer = () => {
  const [loading, setLoading] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // 1. Fetching logic isolated for reusable calls
  const fetchAlerts = async (showLoadingIndicator = false) => {
    try {
      if (showLoadingIndicator) setLoading(true);

      const res = await getSubscriptionAlerts();

      if (res?.status) {
        setUnreadCount(res?.data?.unread_notifications_count || 0);
        setAlerts(res?.data?.subscription_alerts || []);
      } else {
        toast.error(res?.message || "Failed to load alerts");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      if (showLoadingIndicator) setLoading(false);
    }
  };

  // 2. Real-time implementation via Polling (Updates every 30 seconds without refresh)
  useEffect(() => {
    // Initial fetch with full loading indicator
    fetchAlerts(true);

    // Setup background interval to keep data fresh without resetting loading state
    const POLLING_INTERVAL = 30000; // 30 seconds
    const intervalId = setInterval(() => {
      fetchAlerts(false); 
    }, POLLING_INTERVAL);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="student-wrapper">
      <div className="student-card">

        {/* Header */}
        <div className="list-header">
          <div>
            <h5>
              <FaBell className="me-2" />
              Subscription Alerts
            </h5>
            <p className="text-secondary-light">
              Expiring subscription notifications
            </p>
          </div>

          <div className="header-actions">
            <span
              className="badge bg-danger"
              style={{
                padding: "10px 14px",
                fontSize: "14px",
              }}
            >
              {unreadCount} Unread
            </span>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive">
          <table className="user-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>School</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Package</th>
                <th>Expiry Date</th>
                <th>Days Left</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="no-data">
                    Loading Alerts...
                  </td>
                </tr>
              ) : alerts.length === 0 ? (
                <tr>
                  <td colSpan="8" className="no-data">
                    No Alerts Found
                  </td>
                </tr>
              ) : (
                alerts.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>

                    <td>
                      <strong>{item.name}</strong>
                    </td>

                    <td>
                      <FaEnvelope
                        className="me-2"
                        style={{ color: "#2563eb" }}
                      />
                      {item.email}
                    </td>

                    <td>
                      <FaPhone
                        className="me-2"
                        style={{ color: "#16a34a" }}
                      />
                      {item.phone}
                    </td>

                    <td>{item.package_name}</td>
                    <td>{item.plan_expires_at}</td>
                    <td>{item.days_remaining}</td>

                    <td>
                      <span className="badge bg-warning text-dark">
                        <FaExclamationTriangle className="me-1" />
                        Expiring Soon
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default NotificationAlertLayer;